enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.Region.request',
	receive = 'MedicinalBrandsAnalytics.Region.receive',
}

export default ActionTypes;
